export default __webpack_public_path__ + "static/277-5238cbe415882304d4c69f62a27fe804.gif";